<nav *ngIf="navLinks && navLinks.length > 1" [ngClass]="isCollapsed ? 'w-16' : 'w-52'" class="hidden lg:block h-full flex flex-col bg-white rounded-lg overflow-hidden shadow-md shadow-shadow-default transition-all duration-300">
  <div class="flex flex-col h-full min-h-0">
    <!-- Toggle Button -->
    <!-- <div class="flex-shrink-0 p-2 border-b border-gray-200">
      <button
        (click)="toggleNavbar()"
        class="w-full flex items-center p-2 text-gray-600 hover:text-blue-500 hover:bg-gray-50 rounded-lg transition-all duration-200"
        [class]="isCollapsed ? 'justify-center' : 'justify-start'"
        [title]="isCollapsed ? ('Expand sidebar' | transloco) : ('Collapse sidebar' | transloco)"
      >
        <ng-icon [name]="isCollapsed ? 'matKeyboardArrowRight' : 'matKeyboardArrowLeft'" class="flex-shrink-0 transition-transform duration-200" style="font-size: 1.2em;"></ng-icon>
        <span *ngIf="!isCollapsed" class="ml-2 text-sm font-medium transition-opacity duration-200">{{ 'Collapse' | transloco }}</span>
      </button>
    </div> -->

    <!-- Navigation Links -->
    <div class="flex-1 min-h-0 overflow-hidden">
      <ul class="flex flex-col font-medium space-y-0.5 p-1 h-full mt-1.5">
        <ng-container *ngFor="let navLink of navLinks; let i = index; let last = last">
          <li *ngIf="isNavLinkVisible(navLink)" class="relative group">
            
            <!-- Parent with children (expandable) -->
            <ng-container *ngIf="navLink.children">
              <div class="rounded-lg transition-all duration-200 relative">
                <button
                  (click)="toggleNavLink(navLink)"
                  [class]="isCollapsed ? 'justify-center px-2 py-3' : 'px-2 py-2'"
                  [ngClass]="{'bg-blue-100': navLink.isOpen && isCollapsed}"
                  class="w-full flex items-center hover:bg-gray-100 hover:text-gray-900 transition-all duration-200 text-gray-700 rounded-lg"
                  [title]="isCollapsed ? (navLink.label | transloco) : ''"
                >
                  <span [class]="isCollapsed ? 'justify-center' : 'min-w-0 w-full'" class="flex items-center relative">
                    <ng-icon [name]="navLink.icon" class="flex-shrink-0" style="font-size: 1em;"></ng-icon>
                    <!-- Dot indicator for open state in collapsed mode -->
                    <span *ngIf="navLink.isOpen && isCollapsed" class="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-blue-600 rounded-full"></span>
                    <span *ngIf="!isCollapsed" class="block text-left break-words ml-1 flex-1 transition-opacity duration-200 font-medium cursor-pointer"
                      (click)="navigateToFirstChild(navLink); $event.stopPropagation()">
                      {{ navLink.label | transloco }}
                    </span>
                    <ng-icon *ngIf="!isCollapsed" [name]="navLink.isOpen ? 'matKeyboardArrowDown' : 'matKeyboardArrowRight'" class="flex-shrink-0 ml-auto transition-transform duration-200" style="font-size: 1em;"></ng-icon>
                  </span>
                </button>
                
                <!-- Children - expanded view -->
                <ul *ngIf="navLink.isOpen && !isCollapsed" class="space-y-0.5 border-l-2 border-blue-50 ml-2">
                  <li *ngFor="let child of navLink.children">
                    <a *ngIf="isNavLinkVisible(child)"
                       [routerLink]="child.path"
                       [ngClass]="getPathWithoutParams(router.url) === child.path ? 'bg-blue-800 text-white' : 'text-gray-700'"
                       class="block px-4 py-2 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200 rounded-lg"
                       (click)="navigateTo(child.path)">
                      <span class="flex items-center min-w-0">
                        <ng-icon [name]="child.icon" class="flex-shrink-0" style="font-size: 1em;"></ng-icon>
                        <span class="block text-left break-words ml-1 transition-opacity duration-200">
                          {{ child.label | transloco }}
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
                
                <!-- Children - collapsed view (icon only) -->
                <ul *ngIf="navLink.isOpen && isCollapsed" class="space-y-0.5 mt-1 pt-2 border-t-2 border-blue-300 bg-blue-50 rounded-b-lg pb-1 px-1">
                  <li *ngFor="let child of navLink.children" class="relative group/child">
                    <a *ngIf="isNavLinkVisible(child)"
                       [routerLink]="child.path"
                       [ngClass]="getPathWithoutParams(router.url) === child.path ? 'bg-blue-800 text-white' : 'text-gray-700 bg-white'"
                       class="flex items-center justify-center px-2 py-2 hover:bg-blue-100 hover:text-gray-900 transition-all duration-200 rounded shadow-sm"
                       [title]="child.label | transloco"
                       (click)="navigateTo(child.path)">
                      <ng-icon [name]="child.icon" class="flex-shrink-0" style="font-size: 0.85em;"></ng-icon>
                    </a>
                    
                    <!-- Tooltip for collapsed child items -->
                    <div class="absolute left-full top-0 ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 pointer-events-none group-hover/child:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
                      {{ child.label | transloco }}
                    </div>
                  </li>
                </ul>
              </div>
            </ng-container>

            <!-- Simple link (no children) -->
            <ng-container *ngIf="!navLink.children">
              <a [routerLink]="navLink.path"
                 [ngClass]="getPathWithoutParams(router.url) === navLink.path ? 'bg-blue-800 text-white' : 'text-gray-700'"
                 [class]="isCollapsed ? 'justify-center px-2 py-3' : 'px-2 py-2'"
                 class="block hover:bg-gray-100 hover:text-gray-900 transition-all duration-200 rounded-lg"
                 [title]="isCollapsed ? (navLink.label | transloco) : ''"
                 (click)="navigateTo(navLink.path)">
                <span [class]="isCollapsed ? 'justify-center' : 'min-w-0'" class="flex items-center">
                  <ng-icon [name]="navLink.icon" class="flex-shrink-0" style="font-size: 1em;"></ng-icon>
                  <span *ngIf="!isCollapsed" class="block text-left break-words ml-1 transition-opacity duration-200">
                    {{ navLink.label | transloco }}
                  </span>
                </span>
              </a>

              <!-- Tooltip for collapsed state -->
              <div *ngIf="isCollapsed" class="absolute left-full top-0 ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
                {{ navLink.label | transloco }}
              </div>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </div>

    <!-- Date/Time Settings button (bottom of sidebar) -->
    <div class="flex-shrink-0 border-t border-gray-100 p-1">
      <button
        (click)="openDateTimeSettings()"
        [class]="isCollapsed ? 'justify-center px-2 py-3' : 'px-2 py-2'"
        class="w-full flex items-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200"
        [title]="'Date/Time Settings'"
        type="button"
      >
        <ng-icon name="matSettings" class="flex-shrink-0" style="font-size: 1em;"></ng-icon>
        <span *ngIf="!isCollapsed" class="ml-1 text-sm transition-opacity duration-200">
          {{ 'Date/Time Settings' | transloco }}
        </span>
      </button>
    </div>
  </div>
</nav>

<!-- Date/Time Settings Modal (outside <nav> so it's visible on all screen sizes) -->
<div
  *ngIf="showDateTimeSettingsModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
  (click)="closeDateTimeSettings()"
>
  <div
    class="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-lg p-6"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between mb-5">
      <div class="flex items-center gap-2">
        <ng-icon name="matSettings" class="text-gray-600 dark:text-gray-300" style="font-size: 1.3em;"></ng-icon>
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ 'Date/Time Settings' | transloco }}
        </h2>
      </div>
      <button
        (click)="closeDateTimeSettings()"
        class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
        type="button"
        [attr.aria-label]="'Close' | transloco"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Date Format -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {{ 'Date Format' | transloco }}
      </label>
      <select
        [(ngModel)]="stagedDateFormat"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option *ngFor="let opt of dateFormatOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <!-- Footer Buttons -->
    <div class="flex justify-end gap-3">
      <button
        (click)="closeDateTimeSettings()"
        class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
        type="button"
      >
        {{ 'Cancel' | transloco }}
      </button>
      <button
        (click)="saveDateTimeSettings()"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
        type="button"
      >
        {{ 'Save' | transloco }}
      </button>
    </div>
  </div>
</div>